import dayjs from 'dayjs';
import { DURATION_TYPE, TICKET_PACKAGE_ID_MAP } from '../../constants/userConstants';
var proxyMyValidTicketList = function (myValidTicketListBody) {
    var _a, _b;
    if (!((_b = (_a = myValidTicketListBody.result) === null || _a === void 0 ? void 0 : _a.VALIDTICKETLIST[0]) === null || _b === void 0 ? void 0 : _b.PURCHASECODE)) {
        return [];
    }
    return myValidTicketListBody.result.VALIDTICKETLIST.map(function (ticket) {
        var ticketTier = TICKET_PACKAGE_ID_MAP[ticket.PACKAGEID];
        var ticketExpireDate = dayjs(ticket.EXPDATE, 'YYYYMMDDHHmmss').add(-1, 'day').format('YYYY.MM.DD HH:mm까지');
        return {
            productId: ticket.PRODID,
            ticketName: ticket.DISPPRODNAME,
            durationType: ticket.DURATIONTYPE === 5 ? DURATION_TYPE.YEAR : DURATION_TYPE.MONTH,
            ticketExpireDate: ticketExpireDate,
            ticketTier: ticketTier,
            ticketType: ticket.PURCHASECODE,
        };
    });
};
export default proxyMyValidTicketList;
